<template>
    <v-card class="mt-5" height='100%'>
      <v-container fluid class="pa-5">
        <v-row>
          <v-col cols="12">
            <p>Performance <span id="performance"></span> Breakdown -
                <v-btn 
                  text 
                  small
                  color="primary"
                  
                  @click.stop="listDialog= true"
                >
                  See Performance of similar Investors
                </v-btn>              
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon dense small style="color: #e1e4ea; " v-on="on">mdi-information-outline </v-icon>
                </template>
                <span>Performance is estimated and might differ from real performance. Specifically, it may omit short positions and holdings that are not part of our universe.</span>
              </v-tooltip>
            </p> 
            <PerformanceBreakdownChart
              :id="investor"
              :apiEndpoint="'/get-investor-return-breakdown/'"
              date-key="date"
              :bar-keys="[
                'Country',
                'Market',
                'Mom',
                'Quality',
                'Residuals',
                'Risk',
                'Sector',
                'Size',
                'Value',
                'Fx'
              ]"
              line-key="Return"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
              <span>
             
                  <v-dialog v-model="listDialog">
                      <v-card class="px-7" style="background: #121212;">
                        <v-row>
                          <investors-performance-table :element="investor" :type="'similar'"></investors-performance-table>        
                        </v-row>
                        <v-card-actions>    
                          <v-spacer></v-spacer>             
                          <v-btn color="primary" text @click="listDialog = false">Close</v-btn>
                        </v-card-actions> 
                      </v-card>                
                  </v-dialog>
            </span>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
</template>

<script>
  import PerformanceBreakdownChart from "@/components/PerformanceBreakdownChart";
  export default {
    name: 'InvestorAnalyzeComponentChartPerformance',
    props:['investor'],
    components: {
      PerformanceBreakdownChart,
      InvestorsPerformanceTable: () => import('@/components/InvestorsPerformanceTable'),
    },      
    data() {
      return {
        listDialog: false
      }
    }
  }
</script>
